const resizeButtonsContainer = (buttonsContainer, deviceSize) => {
  let buttons = document.querySelectorAll(
    '.user-feature-buttons__buttons .user-feature-buttons__button'
  );

  if (buttons.length == 4) {
    if (deviceSize.isPhone()) {
      console.log('Resized for phone');
      buttonsContainer.style.paddingLeft = '16px';
      buttonsContainer.style.paddingRight = '16px';
    } else if (deviceSize.isTablet()) {
      console.log('Resized for tablets');
      buttonsContainer.style.paddingLeft = '125px';
      buttonsContainer.style.paddingRight = '125px';
    }
  }
};

const showClickedMobileContainer = event => {
  let buttonsContainer = event.target.closest('.user-feature-buttons__buttons');

  let clickedContainer = document.querySelector(
    '.user-feature-buttons__clicked-section-container'
  );

  buttonsContainer.classList.add('is-hidden');
  clickedContainer.classList.remove('is-hidden');
};

const resizeButtons = (buttonsList, newWidth) => {
  buttonsList.forEach(element => {
    element.style.width = newWidth;
  });
};

document.addEventListener('turbo:load', () => {
  let deviceSize = new Sofatutor.Classes.DeviceSizeHelper();
  const buttonsContainer = document.querySelector(
    '.js-user-feature-buttons-buttons'
  );

  const buttonsList = document.querySelectorAll(
    '.user-feature-buttons__button'
  );

  // Resize button container
  resizeButtonsContainer(buttonsContainer, deviceSize);

  //Add listeners to CTAs
  if (buttonsContainer) {
    buttonsContainer.addEventListener('click', event => {
      showClickedMobileContainer(event);
    });

    if (deviceSize.isDesktop() && buttonsList.length == 4) {
      resizeButtons(buttonsList, '373px');
    }
  }
});
